module.exports = __webpack_public_path__ + "007a8fa97856f2ef03ad4c4999d6422d.png";


//////////////////
// WEBPACK FOOTER
// ./img/ArtsApp_symbol.png
// module id = 274
// module chunks = 0